
<template>
  <el-card class="page" v-loading="loading">
    <el-form ref="form" status-icon :model="form" :rules="rules" label-width="160px">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item class="month" label="Month" prop="month">
              <el-date-picker
                popper-class="panel"
                type="month"
                placeholder="Pick a month"
                v-model="form.month"
                style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="Programs" prop="programs">
            <el-select v-model="form.programs" multiple placeholder="Select" style="width: 100%;">
              <el-option
                class="month"
                v-for="program in programs"
                :key="program.id"
                :label="program.name"
                :value="program.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Monthly Activities" prop="activities">
        <el-input :autosize="{ minRows: 6, maxRows: 8}" type="textarea" v-model="form.activities"></el-input>
      </el-form-item>
      <el-form-item label="Program Improvements" prop="improvements">
        <el-input  :autosize="{ minRows: 6, maxRows: 8}" type="textarea" v-model="form.improvements"></el-input>
      </el-form-item>
      <el-form-item label="Customer Feeedback & Achievements" prop="feedback">
        <el-input  :autosize="{ minRows: 6, maxRows: 8}" type="textarea" v-model="form.feedback"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validate">Create</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import firebase from 'firebase'
  import axios from 'axios'
  import {database, auth} from '../main.js'
  import moment from 'moment'
  import {getProgramsMixin} from './getProgramsMixin.js'
  export default {
    mixins: [getProgramsMixin],
    data () {
      return {
        loading: false,
        managerId: '',
        contract: '',
        user: {},
        form: {
          month: '',
          programs: [],
          activities: '',
          improvements: '',
          feedback: ''
        },
        rules: {
          month: [
            { required: true, message: 'Please choose a month', trigger: 'blur' }
          ],
          activities: [
            { required: true, message: 'Please input your monthly activities', trigger: 'blur' },
            { min: 100, message: 'Length should be at least 100 characters', trigger: 'blur' }
          ]
        }
      }
    },
    /* computed: {
      programOptions () {
        const {programs} = this
        if (programs) {
          return Object.keys(programs).map(key => ({
            name: programs[key].name,
            id: key
          }))
        }
      }
    }, */
    methods: {
      validate () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.onSubmit()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      async onSubmit () {
        this.loading = true
        const data = {...this.form}
        data.month = moment(data.month).toISOString();
        data.user = auth.currentUser.uid
        data.managerId = this.managerId
        data.contract = this.contract
        data.status = 'pending'
        data.created = firebase.database.ServerValue.TIMESTAMP
        const newReport = database.ref('/reports').push()
        newReport.set(data)
        const emailConfirm = await axios.post('https://us-central1-operations-60be9.cloudfunctions.net/reportComplete', {
          managerName: this.manager.firstName,
          managerEmail: this.manager.email,
          user: `${this.user.firstName} ${this.user.lastName}`
        })
        console.log('success', emailConfirm)

        this.$refs.form.resetFields()
        this.$notify({
          title: 'Success',
          message: 'Your Status report has been submitted!',
          type: 'success'
        });
        this.$router.replace('dashboard')
      }
    },
    async created () {
      this.loading = true
      const userId = auth.currentUser.uid
      const user = await database.ref(`/users/${userId}`).once('value')
      this.user = user.val()
      const contract = user.val().contract
      this.contract = contract
      this.getPrograms(this.contract)
      const teamId = user.val().teamId
      const team = await database.ref(`/teams/${teamId}`).once('value')
      const managerId = team.val().managerId
      this.managerId = managerId
      const manager = await database.ref(`/users/${managerId}`).once('value')
      this.manager = manager.val()
      this.loading = false
    }
  }
</script>
<style scoped>
  .panel {
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .month {
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .page {
    position: absolute;
    height: calc(100vh - 120px);
    width: calc(100vw - 240px)
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue